import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { FraudCaseRow, FraudListRequest, FraudMovementCase, FraudReviewStatus } from '../../fraud-dashboard.models';
import { buildCaseRows, FraudSessionExpiredError, parseFraudRows } from '../../fraud-dashboard.utils';
import momentJalaali from 'moment-jalaali';
import axios from 'src/app/Service/axios';

@Component({
  selector: 'app-fraud-cases',
  templateUrl: './fraud-cases.component.html',
  styleUrls: ['./fraud-cases.component.css']
})

export class FraudCasesComponent implements OnInit, OnDestroy {
  readonly dateForm = new FormGroup({
    date: new FormControl(momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD'))
  });
  readonly pageSizeOptions = [10, 20, 50];
  reviewStatus: FraudReviewStatus | null = null;
  cases: FraudCaseRow[] = [];
  page = 1;
  pageSize = 20;
  totalRecords = 0;
  loading = false;
  error = '';

  private requestId = 0;
  private requestController?: AbortController;

  constructor(
    private gurdService: GurdServiceService,
    private other: OtherService,
    private notification: NotificationService,
    private router: Router
  ) {}

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.totalRecords / this.pageSize));
  }

  ngOnInit(): void {
    void this.loadCases();
  }

  ngOnDestroy(): void {
    this.requestId++;
    this.requestController?.abort();
  }

  changeStatus(status: FraudReviewStatus | null): void {
    this.reviewStatus = status;
    void this.loadCases(true);
  }

  changePage(page: number): void {
    if (page === this.page || page < 1 || page > this.totalPages) return;
    this.page = page;
    void this.loadCases();
  }

  changePageSize(size: number): void {
    if (!this.pageSizeOptions.includes(size) || size === this.pageSize) return;
    this.pageSize = size;
    void this.loadCases(true);
  }

  async loadCases(resetPage = false): Promise<void> {
    if (resetPage) this.page = 1;
    const requestId = ++this.requestId;
    this.requestController?.abort();
    const controller = new AbortController();
    this.requestController = controller;
    this.cases = [];
    this.totalRecords = 0;
    this.error = '';
    this.loading = true;

    try {
      const user = Number(this.gurdService.decrypt(localStorage.getItem('ID')));
      const session = this.gurdService.decrypt(localStorage.getItem('Session'));
      if (!Number.isInteger(user) || user <= 0 || !session) throw new Error('Missing session');
      const payload: FraudListRequest = {
        iSystemUSer: user,
        strSession: session,
        strDate: this.dateForm.value.date,
        siReviewStatus: this.reviewStatus,
        iPageNumber: this.page,
        iPageSize: this.pageSize
      };
      const response = await axios.post('Fraud_MovementGroup_GetList', payload, { timeout: 30000, signal: controller.signal });
      const rows = parseFraudRows<FraudMovementCase>(response.data);
      if (requestId !== this.requestId) return;
      // An empty server page has no iTotalRecords; return to the first page.
      if (!rows.length && this.page > 1) {
        await this.loadCases(true);
        return;
      }
      this.cases = buildCaseRows(rows);
      const total = Number(rows[0]?.iTotalRecords);
      this.totalRecords = Number.isFinite(total) ? Math.max(rows.length, total) : rows.length;
    } catch (error) {
      if (requestId !== this.requestId) return;
      if (error instanceof FraudSessionExpiredError) {
        this.notification.showError('لطفا وارد سیستم شوید');
        this.other.removeLocalStorage();
        void this.router.navigate(['login'], { queryParams: { error: 'لطفا وارد سیستم شوید' } });
        return;
      }
      this.error = 'دریافت فهرست پرونده‌ها با خطا مواجه شد. دوباره تلاش کنید.';
    } finally {
      if (requestId === this.requestId) this.loading = false;
    }
  }

}
